import { call, take, put } from 'redux-saga/effects';
import axios               from 'axios';
import { SET_USER_VIDEOS } from 'actions/contentActions';


const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/saveVideoLocation.php';

function* saveVideoLocation(): Generator<any,any,any> {
  while(true) {
    try {

        const userInput = yield take('SAVE_VIDEO_LOCATION_SAGA');
        const { userId, videoId, videoTitle, newUserVideos } = userInput.payload;
        
        if (process.env.NODE_ENV === 'development') {

          yield put(SET_USER_VIDEOS( newUserVideos ))
          

        }
        if (process.env.NODE_ENV === 'production') {
      

            const res = yield call( axios.post, endpoint, { userId, videoId, videoTitle });

            if (res.data && res.data.success && res.data.success === 1 ) {
               yield put(SET_USER_VIDEOS( newUserVideos ))
               console.log('success')
            }
            else {
              console.log("can't save video location")
            } 
        }
    }
    catch(err) {
      console.log('err  :  '+err);
    }
    finally {}
  }
}


export default saveVideoLocation;








